import { render } from "./updateButton.vue?vue&type=template&id=a5930b56&scoped=true"
import script from "./updateButton.vue?vue&type=script&lang=js"
export * from "./updateButton.vue?vue&type=script&lang=js"

import "./updateButton.vue?vue&type=style&index=0&id=a5930b56&lang=scss&scoped=scoped"

import exportComponent from "E:\\giteeWorkShowma\\hardware-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5930b56"]])

export default __exports__